import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { useAppNavigate } from "@/routing/useAppNavigate";

export const ScrollToElement = () => {
  const navigate = useAppNavigate();
  const { state } = useRouter().state.location;

  useEffect(() => {
    const { jumpTo } = state as any;

    const hashElement = document.getElementById(jumpTo);

    if (hashElement) {
      hashElement.scrollIntoView({
        behavior: "smooth",
        inline: "nearest",
      });
      navigate({
        state: {
          jumpTo: undefined,
        } as any,
      });
    }
  }, [state, navigate]);

  return null;
};
